/* eslint-disable formatjs/no-literal-string-in-jsx -- Please check and fix */
import cx from 'clsx';
import type { ReactElement } from 'react';
import type { ButtonProps as AriaButtonProps } from 'react-aria-components';
import styles from '../popup.module.css';
import { CloseIcon } from '../../../assets/icons';
import { Button } from '../../button';

interface PopupCloseButtonProps extends AriaButtonProps {
  onPress: () => void;
  className?: string;
}

export function PopupCloseButton({
  onPress,
  className,
  ...props
}: PopupCloseButtonProps): ReactElement {
  return (
    <Button
      aria-label="Close"
      className={cx(styles.close, className)}
      data-testid="modal-close-button"
      iconOnly
      onPress={onPress}
      type="button"
      variant="tertiary"
      {...props}
    >
      <CloseIcon aria-hidden />
    </Button>
  );
}
